module.exports = __webpack_public_path__ + "img/6e46d023235a463242aa7c4fe9041d06.png";